export default __webpack_public_path__ + "static/4-9b23dd49d0fbc938004d2aeef3d55ca7.jpg";